import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RootState } from 'StoreModel';
import { ApplicationDefinition, ApplicationEntry } from 'redux/types/account';
import NewApplication from '../../components/application/new-application';
import styled from 'styled-components';
import { saveApplicationEntryAsync } from '../../redux/actions/application-manager';
import { Modal } from 'semantic-ui-react';
import { Flag } from '../../redux/types/enums';
import { useHistory } from 'react-router-dom';
import { toast } from '../../components/common/toast';
import { Community } from '../../redux/types/account';
import { StyledButton } from 'primitives/Button/style';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const mapStateToProps = (state: RootState) => ({
  literals: state.literals,
  bearer: state.account.session.session.bearer,
  isSavingApplicationEntry: state.loading.saveApplicationEntryFlag,
});

const mapDispatchToProps = {
  saveApplicationEntry: saveApplicationEntryAsync.request,
  cancelSaveApplicationEntryFlag: saveApplicationEntryAsync.cancel,
};

type dispatchType = typeof mapDispatchToProps;

interface Props extends ReturnType<typeof mapStateToProps>, dispatchType {
  applicationDefinition: ApplicationDefinition;
  community: Community;
}

const NewApplicationPage: React.FC<Props> = props => {
  const {
    applicationDefinition,
    saveApplicationEntry,
    community,
    bearer,
    isSavingApplicationEntry,
    literals,
    cancelSaveApplicationEntryFlag,
  } = props;
  const history = useHistory();
  const [showRedirectModal, setShowRedirectModal] = useState<boolean>(false);
  const [isSubmit, setIsSubmit] = useState<boolean>(false);

  const save = (applicationEntry: ApplicationEntry, submitApplication: boolean) => {
    if (submitApplication) setIsSubmit(submitApplication);
    saveApplicationEntry({
      bearer,
      applicationEntry,
      submitApplication,
    });
  };
  const handleSaveApplicationEntry = (applicationEntry: ApplicationEntry) => save(applicationEntry, false);

  const handleSubmitApplicationEntry = (applicationEntry: ApplicationEntry) => save(applicationEntry, true);

  useEffect(() => {
    if (isSavingApplicationEntry === Flag.Success) {
      if (isSubmit) setShowRedirectModal(true);
      else toast(literals.application_saved_successfully, { type: 'success' });
      cancelSaveApplicationEntryFlag(null);
    }
  }, [isSavingApplicationEntry]);

  return (
    <React.Fragment>
      <Container>
        <NewApplication
          saveApplicationEntry={handleSaveApplicationEntry}
          community={community}
          submitApplication={handleSubmitApplicationEntry}
          applicationDefinition={applicationDefinition}
          isSavingApplicationEntry={isSavingApplicationEntry}
        />
        {showRedirectModal && (
          <Modal style={{ maxWidth: '30em' }} open={true}>
            <Modal.Header>{literals.application_new_success_message}</Modal.Header>
            <Modal.Content>
              <div style={{ marginBottom: '1em' }}>{literals.application_new_success_message_2}</div>
              <StyledButton
                onClick={() => {
                  setShowRedirectModal(false);
                  history.push('/account');
                }}
              >
                {literals.application_new_success_button}
              </StyledButton>
            </Modal.Content>
          </Modal>
        )}
      </Container>
    </React.Fragment>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(NewApplicationPage);
